var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"depressed":"","text":""},on:{"click":_vm.doLogout}},[_c('v-icon',[_vm._v("mdi-logout")]),_c('span',{staticClass:"ml-7"},[_vm._v("Log Out")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }